export const MAX_FILES_COUNT = 3;
export const MAX_SIZE_IN_MB = 5;
export const ACCEPTED_FILE_TYPES = '.jpg, .jpeg, .pdf, .png';

export const TIME_OF_FAILURE_OPTIONS = ({ t }) => [
  { value: '00:00 - 04:00', label: '00:00 - 04:00' },
  { value: '04:00 - 08:00', label: '04:00 - 08:00' },
  { value: '08:00 - 12:00', label: '08:00 - 12:00' },
  { value: '12:00 - 16:00', label: '12:00 - 16:00' },
  { value: '16:00 - 20:00', label: '16:00 - 20:00' },
  { value: '20:00 - 00:00', label: '20:00 - 00:00' },
];

export const FAILURE_TYPES = ({ lang }) => {
  return lang === 'en'
    ? [
        {
          value: 'FAILURE_TO_SUBMIT_INVOICES_INTEGRATION_ERROR',
          label: 'Failure to submit invoices - Integration error',
        },
        {
          value: 'FAILURE_TO_SUBMIT_INVOICES_INTERNET_ERROR',
          label: 'Failure to submit invoices – Internet connectivity error',
        },
        {
          value: 'FAILURE_TO_GENERATE_INVOICES_SOLUTION_ERROR',
          label: 'Failure to generate invoices – Solution error',
        },
        {
          value: 'FAILURE_TO_ONBOARD_OR_RENEW_SOLUTION',
          label: 'Failure to onboard / renew E-invoicing Solution',
        },
        {
          value: 'OTHER',
          label: 'Other',
        },
      ]
    : [
        {
          value: 'FAILURE_TO_SUBMIT_INVOICES_INTEGRATION_ERROR',
          label: 'فشل في إرسال الفواتير - خطأ في عملية التكامل',
        },
        {
          value: 'FAILURE_TO_SUBMIT_INVOICES_INTERNET_ERROR',
          label: 'فشل في إرسال الفواتير - خطأ في الربط بعملية التكامل',
        },
        {
          value: 'FAILURE_TO_GENERATE_INVOICES_SOLUTION_ERROR',
          label: 'فشل في إنشاء الفواتير – خطأ في الحل',
        },
        {
          value: 'FAILURE_TO_ONBOARD_OR_RENEW_SOLUTION',
          label: 'فشل في تسجيل / تجديد الحل الخاص بالفاتورة الإلكترونية',
        },
        {
          value: 'OTHER',
          label: 'أخرى',
        },
      ];
};

export const getFailureTypeLabel = ({ failureType, lang }) => {
  return FAILURE_TYPES({ lang }).find((v) => v.value === failureType)?.label;
};

const isToday = (date) => {
  if (!date) {
    return false;
  }
  const today = new Date();
  const d = new Date(date);
  return (
    d.getFullYear() === today.getFullYear() &&
    d.getMonth() === today.getMonth() &&
    d.getDate() === today.getDate()
  );
};

export const getAvailableTimeOptions = ({ t, selectedDate }) => {
  const allOptions = TIME_OF_FAILURE_OPTIONS({ t });
  if (!isToday(selectedDate)) {
    return allOptions;
  }

  const currentHour = new Date().getHours();
  return allOptions.filter((option) => {
    const startHour = parseInt(option.value.split(':')[0], 10);
    return startHour <= currentHour;
  });
};
